import { apolloClient } from "@/plugins/vue-apollo.js";

const toggleRoomStatus = async ( variables) => {
    let responseFromApi = await apolloClient.mutate({
        mutation: require("@/landlord/api/mutations/toggle_room_status.graphql"),
        variables:variables,

    }).catch(() => {
        return {data:null}
    })
    return responseFromApi;

};

export { toggleRoomStatus };